export const FETCH_INTERACTIONS_SETTING_IN_PROGRESS = 'FETCH_INTERACTIONS_SETTING_IN_PROGRESS';
export const FETCH_INTERACTIONS_SETTING_SUCCESS = 'FETCH_INTERACTIONS_SETTING_SUCCESS';
export const FETCH_INTERACTIONS_SETTING_ERROR = 'FETCH_INTERACTIONS_SETTING_ERROR';
export const FETCH_INTERACTIONS_NOTE_SUCCESS = 'FETCH_INTERACTIONS_NOTE_SUCCESS';
export const FETCH_INTERACTIONS_NOTE_ERROR = 'FETCH_INTERACTIONS_NOTE_ERROR';
export const CLEAR_INTERACTION_SETTING = 'CLEAR_INTERACTION_SETTING';
export const FETCH_INTERACTIONS_FAVOURITES_LIST = 'FETCH_INTERACTIONS_FAVOURITES_LIST';
export const ADD_REMOVE_INTERACTION_FAVOURITES = 'ADD_REMOVE_INTERACTION_FAVOURITES'
export const ADD_REMOVE_INTERACTION_FAVOURITES_ERROR = 'ADD_REMOVE_INTERACTION_FAVOURITES_ERROR'
